import React from "react";

const Terms = (props) => {
    return <h1>Terms Page</h1>
}

export default Terms